// PermissionDenied.jsx
import React from "react"
import "./PermissionDenied.css"

const PermissionDenied = ({
  title = "You don't have permission to view this page",
  description = "Either go back to the previous page or log in as a different user.",
}) => {
  return (
    <div className="permission-denied">
      <div className="permission-denied__content">
        {/* Warning Icon */}
        <svg
          className="permission-denied__icon"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M29.3 8.2L6.8 48.5C5.7 50.5 7.1 53 9.4 53H54.6C56.9 53 58.3 50.5 57.2 48.5L34.7 8.2C33.5 6.1 30.5 6.1 29.3 8.2Z"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <path
            d="M32 21V35"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
          />

          <circle cx="32" cy="43" r="2.5" fill="currentColor" />
        </svg>

        <h1 className="permission-denied__title">{title}</h1>
        <p className="permission-denied__description">{description}</p>
      </div>
    </div>
  )
}

export default PermissionDenied
export { PermissionDenied }
